// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.me-entry-number {
	flex: 0 0 3rem;
	color: #9ca3af;
}
`, "",{"version":3,"sources":["webpack://./src/app/components/modal-entry-search/modal-entry-search.component.css"],"names":[],"mappings":"AAAA;CACC,cAAc;CACd,cAAc;AACf","sourcesContent":[".me-entry-number {\n\tflex: 0 0 3rem;\n\tcolor: #9ca3af;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
